export type OptionState = 'default' | 'selected' | 'correct' | 'wrong';

export interface OptionItemProps {
  optionId: string;
  content: string;
  state: OptionState;
  onSelect: () => void;
  tabIndex?: number;
}

const stateStyles: Record<OptionState, string> = {
  default: 'border-slate-200 bg-white text-slate-800 hover:border-slate-300 hover:bg-slate-50',
  selected: 'border-primary-400 bg-primary-50 text-primary-800',
  correct: 'border-success-300 bg-success-50 text-success-800',
  wrong: 'border-error-300 bg-error-50 text-error-800',
};

const badgeStyles: Record<OptionState, string> = {
  default: 'bg-slate-100 text-slate-700',
  selected: 'bg-primary-600 text-white',
  correct: 'bg-success-600 text-white',
  wrong: 'bg-error-600 text-white',
};

export function OptionItem({ optionId, content, state, onSelect, tabIndex = 0 }: OptionItemProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      tabIndex={tabIndex}
      className={`flex w-full items-start gap-4 rounded-lg border-2 p-4 text-left transition-colors duration-150 ${stateStyles[state]}`}
      aria-pressed={state === 'selected'}
      aria-label={`选项 ${optionId}`}
      role="radio"
    >
      <span
        className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg text-sm font-semibold ${badgeStyles[state]}`}
      >
        {optionId}
      </span>
      <span className="flex-1 pt-0.5 text-base leading-relaxed">{content}</span>
    </button>
  );
}
